import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import RenderSections from '@/components/probaworkflows_base_components/RenderMainSections/RenderMainSections.vue';
import {
  GET_ASSIGNED_WIDGETS,
  get_headers,
  GET_TABS,
  EDIT_ENTITY_NAME_URL,
  GET_APPLICATION_STATUS,
  LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL,
} from '@/utils/constants/constants';
import alert_mixin from '@/utils/mixins/alert_mixin';
import EntityDocuments from "@/views/probaworkflows_base/entity/entity_applications/entity_documents/EntityDocuments.vue";
import RequestedInformationUpdate from "@/views/probaworkflows_base/entity/requested_information/requested_infomation_update/RequestedInformationUpdate.vue";
import ESigning from '@/views/probaworkflows_base/management/template_managment/e_signing/ESigning.vue';
import VerificationOverview from '@/views/probaworkflows_base/management/trust_applications/verification_managment/verification_overview/VerificationOverview.vue';
import OnboardingComplianceComponent from '@/components/probaworkflows_base_components/OnboardingComplianceChecklistComponent/OnboardingComplianceComponent.vue';
import axios from 'axios';
import ApplicationOverviewDetails from "../application_overview_details/ApplicationOverviewDetails.vue";
import EntityInvoiceOverview from "../entity_invoice_overview/EntityInvoiceOverview.vue";
import EntityVerificationResults from "../entity_verification_results/EntityVerificationResults.vue";
import EntityComplianceAnswers from "@/components/probaworkflows_base_components/EntityComplianceAnswers/EntityComplianceAnswers.vue";
export default {
  name: "EntityApplicationOverview",
  mixins: [alert_mixin],
  components: {
    NavigationBackButton,
    ApplicationOverviewDetails,
    EntityInvoiceOverview,
    ESigning,
    VerificationOverview,
    RequestedInformationUpdate,
    EntityDocuments,
    RenderSections,
    EntityVerificationResults,
    OnboardingComplianceComponent,
    EntityComplianceAnswers
  },
  data: () => ({
    active_master_tab: 'profile', // dashboard category
    active_tab: 'Overview',       // sub-tab
    application_status: "",
    requests: [],
    headers: get_headers(),
    visible_tabs: [],
    db_tabs: [],
    application_form_id: null,
    entity_name: sessionStorage.getItem('entity_name'),
    show_edit_entity_modal: false,
    current_edit_entity: {
      first_name: '',
      last_name: ''
    },
    openSections: {
      onboarding: true, // Set to true if you want it open by default
      documents: false,
      compliance: false
    },
    child_entity_tab_map: {},
    child_tabs: [],
  }),
  computed: {
    application_id() { return this.get_id_from_route_or_storage('application_id'); },
    entity_profile_id() { return this.get_id_from_route_or_storage('entity_profile_id'); },
    profile_role_form_id() { return this.get_id_from_route_or_storage('profile_role_form_id'); },
    status_from_route() { return sessionStorage.getItem('application_status') || ""; },
    
    // Categorization Logic
   filtered_sub_tabs() {
      // Return only profile-related tabs for the sidebar
      if (this.active_master_tab === 'profile') {
        return this.visible_tabs.filter(tab => 
          !tab.label.toLowerCase().includes('compliance') && 
          !['Documents', 'Compliance'].includes(tab.id)
        );
      }
      // Return empty for others so vertical sidebar disappears
      return [];
    },

    content_type() {
      if (this.is_db_main_section_tab(this.active_tab)) return 'dynamic';
      const static_tabs = ['Overview', 'Verification', 'Requests', 'Documents', 'E-Signing', 'Invoices', 'Compliance'];
      return static_tabs.includes(this.active_tab) ? this.active_tab : 'none';
    },
  },
  mounted() {
    this.fetch_assigned_widgets().then(async () => {
      await this.inject_child_entity_type_tabs();
      const saved_tab = sessionStorage.getItem('active_tab');

      const saved_is_placeholder =
        this.is_main_sections_placeholder({ id: saved_tab, label: saved_tab }) ||
        this.is_sub_entities_placeholder({ id: saved_tab, label: saved_tab });

      if (saved_tab && !saved_is_placeholder) {
        this.active_tab = saved_tab;
      } else if (this.visible_tabs.length > 0) {
        this.select_tab(this.visible_tabs[0].id);
      }

      this.fetch_main_sections_tabs();
    });

    this.get_application_status();
  },

  methods: {
    select_master_tab(masterId) {
      this.active_master_tab = masterId;
      if (this.filtered_sub_tabs.length > 0) {
        this.select_tab(this.filtered_sub_tabs[0].id);
      }
    },

    get_tab_icon(tabId) {
      const icons = {
        personal_information: 'bi bi-person',
        contact_details: 'bi bi-telephone',
        employment: 'bi bi-briefcase',
        banking_information: 'bi bi-bank',
        'Verification': 'bi bi-shield-check',
        'Overview': 'bi bi-grid',
        'attributes': 'bi bi-sliders',
        'Journal': 'bi bi-journal-text',
        'Requests': 'bi bi-inbox',
        'Asset Registry': 'bi bi-box-seam',
        'E-Signing': 'fa-solid fa-file-contract'
      }

      return icons[tabId] || 'bi bi-folder'
  },

    get_id_from_route_or_storage(name) {
      let from_route = null;

      switch (name) {
        case "application_id":
          from_route = this.$route?.query?.application_id ?? null;
          break;
        case "profile_role_form_id":
          from_route = this.$route?.query?.profile_role_form_id ?? null;
          break;
        case "form_main_section_id":
          from_route = this.$route?.query?.form_main_section_id ?? null;
          break;
        case "entity_profile_id":
          from_route = this.$route?.query?.entity_profile_id ?? null;
          break;
        default:
          return null; // not allowed
      }

      let from_storage = null;
      try {
        if (typeof window !== "undefined" && window.sessionStorage) {
          from_storage = window.sessionStorage.getItem(name);
        }
      } catch (err) {
        // sessionStorage may be blocked/unavailable (e.g., Safari Private Mode, SSR)
        from_storage = null;
      }

      const raw = from_route ?? from_storage ?? null;
      if (raw == null || raw === "") return null;

      const n = Number(raw);
      return Number.isNaN(n) ? raw : n;
    },

    get_assigned_children(parent_entity_type_id) {
      if (!parent_entity_type_id) return Promise.resolve([]);

      return axios.get(LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL, {
        headers: this.headers,
        params: { parent_entity_type_id },
      })
      .then(res => {
        if (res.data?.status !== "success") return [];

        const payload = res.data?.data;
        return Array.isArray(payload) ? payload : (payload?.assigned_children || []);
      })
      .catch(() => []);
    },

    async inject_child_entity_type_tabs() {
      const parent_entity_type_id = Number(
        this.$route?.query?.entity_type_id ??
        sessionStorage.getItem("entity_type_id") ??
        0
      );

      if (!parent_entity_type_id) return;

      const rows = await this.get_assigned_children(parent_entity_type_id);

      const child_tabs = (rows || [])
        .map(r => {
          const id = Number(r.child_entity_type_id || 0);
          const name = String(r.child_entity_type_name || "Entity Type");

          return {
            id: `child-${id}`,
            label: name,
            has_dropdown: true,
            _child_entity_type_id: id,
            _is_child_type_tab: true,
          };
        })
        .filter(t => t._child_entity_type_id);

      // 1) Remove previously injected child tabs (avoid duplicates)
      this.visible_tabs = (this.visible_tabs || []).filter(
        t => !String(t?.id || "").startsWith("child-")
      );

      // 2) Find the SUB ENTITIES placeholder position (this is the correct anchor)
      const sub_entities_index = (this.visible_tabs || []).findIndex(t =>
        this.is_sub_entities_placeholder(t)
      );

      // 3) Insert where sub-entities used to be:
      // - If placeholder exists: replace it with child tabs
      // - If not: fallback to after application_data / after application_forms / after first tab
      if (sub_entities_index !== -1) {
        this.visible_tabs.splice(sub_entities_index, 1, ...child_tabs);
      } else {
        const application_data_index = (this.visible_tabs || []).findIndex(t => {
          const k = this.normalize_tab_key(t?.id || t?.label);
          return k === "application_data";
        });

        const application_forms_index = (this.visible_tabs || []).findIndex(t => {
          const k = this.normalize_tab_key(t?.id || t?.label);
          return k === "application_forms";
        });

        const insert_index =
          application_data_index !== -1
            ? application_data_index + 1
            : application_forms_index !== -1
              ? application_forms_index + 1
              : 1;

        this.visible_tabs.splice(insert_index, 0, ...child_tabs);
      }

      // 4) Build mapping
      this.child_entity_tab_map = {};
      child_tabs.forEach(t => {
        this.child_entity_tab_map[t.id] = {
          id: t._child_entity_type_id,
          name: t.label,
        };
      });

      this.child_tabs = child_tabs;

      // 5) Safety: ensure the placeholder is gone even if splice didn't happen
      this.visible_tabs = (this.visible_tabs || []).filter(t => !this.is_sub_entities_placeholder(t));
    },

    save_edited_entity() {
      const payload = {
        entity_id: this.entity_profile_id,
        name: this.current_edit_entity.name
      };

      axios.post(EDIT_ENTITY_NAME_URL, payload, { headers: this.headers })
        .then(() => {
          this.entity_name = payload.name;
          sessionStorage.setItem("entity_name", payload.name);
          this.show_edit_entity_modal = false;
          this.show_success("Entity name updated successfully.");
        })
        .catch(error => {
          const message =
            error?.response?.data?.message ||
            error.message ||
            "Failed to update entity name.";
          this.show_error(message);
        });
    },


    open_edit_entity_modal() {
      this.current_edit_entity.name = this.entity_name || "";
      this.show_edit_entity_modal = true;
    },

    select_tab(id) {
      this.active_tab = id;
      sessionStorage.setItem('active_tab', id);
    },

    auto_set_master_tab(subTabId) {
       // Logic to find which card the tab belongs to on page refresh
       if (subTabId === 'Documents') this.active_master_tab = 'documents';
       else if (subTabId.toLowerCase().includes('compliance')) this.active_master_tab = 'compliance';
       else this.active_master_tab = 'profile';
    },

    is_db_main_section_tab(id) {
      return typeof id === 'string' && id.startsWith('ms-');
    },

    dropdown_forms_id(id) {
       if (!this.is_db_main_section_tab(id)) return null;
      const raw = id.split('-')[1];
      return Number(raw);
    },

    tab_label(id) {
      const all = [...this.visible_tabs, ...this.db_tabs];
      return (all.find(t => t.id === id)?.label) || 'Form';
    },

    fetch_assigned_widgets() {
      const request_params = {
        entity_profile_id: this.entity_profile_id,
      };

      return axios
        .get(GET_ASSIGNED_WIDGETS, {
          params: request_params,
          headers: this.headers,
        })
        .then(({ data }) => {
          // Populate all_tabs
          this.all_tabs = data.map(item => ({
            id: item.widget.widget_name,
            label: item.widget.widget_display_name,
            has_dropdown: true,
          }));

          // Populate dropdown_options
          this.dropdown_options = Object.fromEntries(
            data.map(item => [
              item.widget.widget_name,
              [{ value: item.widget.widget_name, label: item.widget.widget_display_name }]
            ])
          );

          this.visible_tabs = (this.all_tabs || []);
        })
        .catch(error => {
          const message =
            error?.response?.data?.message ||
            error.message ||
            "Failed to load widgets";
          this.show_error(message);
        });
    },

    normalize_tab_key(val) {
      return String(val || "")
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "_")
        .replace(/-/g, "_");
    },

    is_sub_entities_placeholder(tab) {
      const id = this.normalize_tab_key(tab?.id);
      const label = this.normalize_tab_key(tab?.label);
      return id === "sub_entities" || label === "sub_entities" || label === "sub_entities_widget";
    },

    is_main_sections_placeholder(tab) {
      const id = this.normalize_tab_key(tab?.id);
      const label = this.normalize_tab_key(tab?.label);

      // depending on what backend sends
      return (
        id === "main_sections" ||
        label === "main_sections" ||
        id === "application_forms" ||       // if you use application_forms as placeholder
        label === "application_forms"
      );
    },


    fetch_main_sections_tabs() {
      const params = {
        application_id: this.application_id,
        entity_profile_id: this.entity_profile_id,
      };

      axios.get(GET_TABS, { params, headers: this.headers })
        .then(res => {
          this.application_form_id = res.data.data.application_form_id;
          const rows = res?.data?.data?.data || [];

          const dynamic_tabs = rows.map(t => ({
            id: `ms-${t.id}`,
            label: t.name,
            _fmsId: t.id,
          }));

          this.db_tabs = dynamic_tabs;

          if (!Array.isArray(this.visible_tabs)) this.visible_tabs = [];

          const placeholder_index = this.visible_tabs.findIndex(t => this.is_main_sections_placeholder(t));

          if (placeholder_index !== -1) {
            this.visible_tabs.splice(placeholder_index, 1, ...dynamic_tabs);
          } else {
            const application_forms_index = this.visible_tabs.findIndex(t =>
              this.normalize_tab_key(t?.id) === "application_forms"
            );

            if (application_forms_index !== -1) {
              this.visible_tabs.splice(application_forms_index + 1, 0, ...dynamic_tabs);
            } else {
              this.visible_tabs.push(...dynamic_tabs);
            }
          }
          this.visible_tabs = this.visible_tabs.filter(t => !this.is_main_sections_placeholder(t));
        })
        .catch(e => {
          this.show_error?.(e?.response?.data?.message || e.message || 'Failed to load tabs');
        });
    },


    get_application_status() {
      const params = {
        application_id: this.application_id,
      };

      axios.get(GET_APPLICATION_STATUS, { params, headers: this.headers })
        .then(response => {
          this.application_status = response.data.application_status;
        })
        .catch(() => {
          this.show_error?.('Failed to retrieve application status');
        });
    },
  }
}